import { type HTMLAttributes } from 'react'
import { cn } from '@/lib/cn'
import styles from './Spinner.module.scss'

/** Indicador de carregamento de 14 px. Decorativo: o rótulo no gerúndio fica no botão. */
export function Spinner({ className, ...rest }: HTMLAttributes<HTMLSpanElement>) {
  return <span aria-hidden className={cn(styles.spinner, className)} {...rest} />
}

export interface SkeletonProps extends HTMLAttributes<HTMLSpanElement> {
  width?: number | string
  height?: number | string
  round?: boolean
}

/** Linha de esqueleto em surface-raised, para listas que estão carregando. */
export function Skeleton({ width = '100%', height = 10, round, className, style, ...rest }: SkeletonProps) {
  return (
    <span
      aria-hidden
      className={cn(styles.skeleton, round && styles.round, className)}
      style={{ width, height, ...style }}
      {...rest}
    />
  )
}
